module.exports = __webpack_public_path__ + "static/media/0.69814550.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/pants/0.png
// module id = 1381
// module chunks = 0